import { connect } from "react-redux";

import NotificationsComponent from "../components/Notifications.Component";

function mapStateToProps(state) {
  return {
    notifications: state.notifications,
  };
}

function mapDispatchToProps() {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationsComponent);
